import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Organisations")
], -1)
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border ms-3 mt-4"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "px-0 py-2" }
const _hoisted_11 = { class: "card-body d-flex align-items-center hover-shadow-soft" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "circle",
  style: {"background":"#f4f4f4"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-city fa-xs",
    style: {"color":"#7a7a7a"}
  })
], -1)
const _hoisted_13 = { class: "d-flex flex-column me-auto" }
const _hoisted_14 = { class: "ms-3 mb-1" }
const _hoisted_15 = { class: "ms-3 smallText" }
const _hoisted_16 = { class: "ms-4 me-2 smallText" }
const _hoisted_17 = {
  class: "dropdown dropdown-menu shadow-3-strong",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

import { onMounted, onUnmounted, ref } from "vue";
import { Ref } from "vue";
import CreateOrganisationModal from "@/views/organisations/CreateOrganisationModal.vue";
import TableView from "@/components/TableView.vue";
import { useFirebaseStore } from "@/stores/firebase-store";
import { Organisation } from "@/model/organisation";
import { useRouter } from "vue-router";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import EditOrganisationModal from "@/views/organisations/EditOrganisationModal.vue";
import { ApiService } from "@/api-service";
import { getFunctions } from "firebase/functions";


const __default__ = {
  name: "OrganisationsList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let editingOrganisation: Ref<Organisation | null> = ref(null);

let isShowingCreateOrganisationModal: Ref<boolean> = ref(false);
let isShowingEditOrganisationModal: Ref<boolean> = ref(false);
let isShowingOrganisationEnabledModal: Ref<boolean> = ref(false);

let isLoadingEnableOrganisation: Ref<boolean> = ref(false);

const firebaseStore = useFirebaseStore();
const router = useRouter();
const apiService = new ApiService(getFunctions());

function toggleCreateOrganisationModal(visible: boolean) {
  isShowingCreateOrganisationModal.value = visible;
}

function toggleEditOrganisationModal(
  visible: boolean,
  organisation?: Organisation
) {
  editingOrganisation.value = organisation ?? null;
  isShowingEditOrganisationModal.value = visible;
}

function toggleOrganisationEnabledModal(
  visible: boolean,
  organisation?: Organisation
) {
  editingOrganisation.value = organisation ?? null;
  isShowingOrganisationEnabledModal.value = visible;
}

function goToOrganisation(organisation: Organisation) {
  router.push({
    name: `employeeList`,
    params: { organisationId: organisation.id },
  });
}

async function toggleOrganisationEnabled(organisation: Organisation) {
  isLoadingEnableOrganisation.value = true;
  await apiService.editOrganisation(
    organisation.id,
    undefined,
    !organisation.isActive
  );
  isShowingOrganisationEnabledModal.value = false;
  isLoadingEnableOrganisation.value = false;
  editingOrganisation.value = null;
}

onMounted(() => {
  firebaseStore.subscribeOrganisations();

  editingOrganisation.value = null;

  isShowingCreateOrganisationModal.value = false;
  isShowingEditOrganisationModal.value = false;
  isShowingOrganisationEnabledModal.value = false;

  isLoadingEnableOrganisation.value = false;
});

onUnmounted(() => {
  firebaseStore.unsubscribeOrganisations();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg btn-floating",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCreateOrganisationModal(true)))
            }, _hoisted_6)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_unref(firebaseStore).loadingOrganisations)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : (_openBlock(), _createBlock(TableView, {
              key: 1,
              borderless: true
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firebaseStore).organisations, (organisation) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: organisation,
                    onClick: ($event: any) => (goToOrganisation(organisation))
                  }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card clickable", {
                  disabled: organisation.isActive === false,
                }])
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(organisation.name), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(organisation.id), 1)
                          ]),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(organisation.isActive ? "Active" : "Disabled"), 1),
                          _createElementVNode("i", {
                            class: "fas fa-ellipsis-v me-2 clickable btn-overflow",
                            id: "dropdownMenuButton1",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }),
                          _createElementVNode("ul", _hoisted_17, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: _withModifiers(($event: any) => (
                          toggleEditOrganisationModal(true, organisation)
                        ), ["stop"])
                              }, "Edit Organisation", 8, _hoisted_18)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: _normalizeClass(["dropdown-item", { 'text-danger': organisation.isActive }]),
                                onClick: _withModifiers(($event: any) => (
                          toggleOrganisationEnabledModal(true, organisation)
                        ), ["stop"])
                              }, _toDisplayString(organisation.isActive
                            ? "Disable Organisation"
                            : "Enable Organisation"), 11, _hoisted_19)
                            ])
                          ])
                        ])
                      ], 2)
                    ])
                  ], 8, _hoisted_9))
                }), 128))
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(CreateOrganisationModal, {
      "is-visible": _unref(isShowingCreateOrganisationModal),
      onHideModal: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isShowingCreateOrganisationModal) //@ts-ignore
 ? isShowingCreateOrganisationModal.value = false : isShowingCreateOrganisationModal = false))
    }, null, 8, ["is-visible"]),
    _createVNode(EditOrganisationModal, {
      "is-visible": _unref(isShowingEditOrganisationModal),
      onHideModal: _cache[3] || (_cache[3] = ($event: any) => (toggleEditOrganisationModal(false))),
      organisation: _unref(editingOrganisation)
    }, null, 8, ["is-visible", "organisation"]),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": _unref(editingOrganisation)?.isActive ? 'Disable' : 'Enable',
      "is-visible": _unref(isShowingOrganisationEnabledModal),
      loading: _unref(isLoadingEnableOrganisation),
      title: 
      _unref(editingOrganisation)?.isActive
        ? 'Confirm Disable Organisation'
        : 'Confirm Enable Organisation'
    ,
      message: 
      'Are you sure you want to ' +
      (_unref(editingOrganisation)?.isActive ? 'disable ' : 'enable ') +
      _unref(editingOrganisation)?.name +
      '?'
    ,
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (toggleOrganisationEnabled(_unref(editingOrganisation)))),
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (toggleOrganisationEnabledModal(false))),
      onHideModal: _cache[6] || (_cache[6] = ($event: any) => (toggleOrganisationEnabledModal(false)))
    }, null, 8, ["confirm-button-text", "is-visible", "loading", "title", "message"])
  ], 64))
}
}

})